export let apiConfig;
export const initApiConfig = (baseUrl, localStore, showLog = false) => {
    apiConfig = {
        baseUrl,
        showLog,
        localStore
    };
};
